import React from "react";
import ContractInvoicePdf from "../pages/jobs/ContractInvoicePdf";
import Contracts from "../pages/jobs/Contracts";
import ContractsPrint from "../pages/jobs/ContractsPrint";
import ContractsView from "../pages/jobs/ContractsView";
import { Route, Routes } from "react-router-dom";
import ContractsEdit from "../pages/jobs/ContractsEdit";

import JobCompletionReportPdf from "../pages/jobs/JobCompletionReportPdf";

export default function ContractRoutes() {
  return (
    <Routes>
      <Route path="" element={<Contracts />} />
      <Route
        path="/view/:organization_id/contract/:contract"
        element={<ContractsView />}
      />
      <Route
        path="/view/:organization_id/contract/:contract/edit"
        element={<ContractsEdit />}
      />
      <Route
        path="/view/:organization_id/contract/:contract/contractPrint"
        element={<ContractsPrint />}
      />
      <Route
        path="/view/:organization_id/contract/:contract/completionReportPdf"
        element={<JobCompletionReportPdf />}
      />
      <Route path="/invoice" element={<ContractInvoicePdf />} />
    </Routes>
  );
}
